import React from 'react';
import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../../../links/API_LINKS';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/material';
import AllEventHeader from './AllEventHeader';

const Index = ({ currentBatch }) => {
  const fetchCurrentBatchEvents = async () => {
    const res = await axios.get(API_URL + '/event/get-all', {
      params: { batchId: currentBatch._id },
    });
    return res;
  };
  const { status, data } = useQuery(
    `fetchCurrentBatchEvents${currentBatch._id}`,
    fetchCurrentBatchEvents
  );
  return (
    <div>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <div>Error fetching data</div>}
      {status === 'success' && (
        <AllEventHeader data={data.data.data} currentBatch={currentBatch} />
      )}
    </div>
  );
};

export default Index;
